export const GET_PLATFORM_REQUEST = 'GET_PLATFORM_REQUEST'
export const GET_PLATFORM_SUCCESS = 'GET_PLATFORM_SUCCESS'
export const GET_PLATFORM_FAILED = 'GET_PLATFORM_FAILED'
